/**
 * Department do usuário no sistema.
 * Definido aqui para evitar dependência circular durante HMR.
 */
export enum UserDepartment {
  CASTING = "CASTING",
  REBOUCAS = "REBOUCAS",
  FRADIQUE = "FRADIQUE",
  PHOTO_LAB = "PHOTO_LAB",
}

/**
 * Slug de department usado nas URLs (kebab-case).
 * Exemplo: /casting/talentos, /laboratorio/talentos
 */
export type DepartmentSlug = "casting" | "reboucas" | "fradique" | "laboratorio";

/**
 * Mapeamento de UserDepartment para slug de URL (kebab-case).
 */
export const DEPARTMENT_TO_SLUG: Record<UserDepartment, DepartmentSlug> = {
  [UserDepartment.CASTING]: "casting",
  [UserDepartment.REBOUCAS]: "reboucas",
  [UserDepartment.FRADIQUE]: "fradique",
  [UserDepartment.PHOTO_LAB]: "laboratorio",
};

/**
 * Mapeamento reverso: slug de URL para UserDepartment.
 */
export const SLUG_TO_DEPARTMENT: Record<DepartmentSlug, UserDepartment> = {
  casting: UserDepartment.CASTING,
  reboucas: UserDepartment.REBOUCAS,
  fradique: UserDepartment.FRADIQUE,
  laboratorio: UserDepartment.PHOTO_LAB,
};

/**
 * Valida se um slug é um department válido.
 * Deriva dinamicamente os slugs válidos do mapeamento SLUG_TO_DEPARTMENT.
 *
 * @param slug - String a ser validada
 * @returns True se o slug é válido, false caso contrário
 */
export function isDepartmentSlugValid(slug: string): slug is DepartmentSlug {
  return slug in SLUG_TO_DEPARTMENT;
}
